<title>
  Request a presentantion MyEnergy: Control Your energy consumption costs
</title>
<meta
  name="description"
  content="Maximize energy efficiency and optimize costs with MyEnergy's comprehensive monitoring and automation services. Our customized platform for industrial customers provides digitized data insights, customized consumption plans and real-time market insights. Digitalisation of their actual and historical power consumption data, tailored to their specific activities. Minimizing the purchase costs of the volume of power required for the scheduled activities of the manufacturing facilities."
/>

<!-- Form -->
<section class="container-main" #containerMain>
  <div class="main">
    <div class="main-text">
      <h6>I CONTROL MY ENERGY</h6>
      <h1>
        {{ "request-a-presentation.main.text.h1" | translate }}
        <span style="color: #038846">{{
          "request-a-presentation.main.text.h2" | translate
        }}</span>
        {{ "request-a-presentation.main.text.h3" | translate }}
      </h1>
      <h5>{{ "request-a-presentation.main.text.h5" | translate }}</h5>
      <img
        src="../../assets/images/eit-EU.webp"
        alt="Co-funded by the European Union"
      />
    </div>
    <div class="main-form">
      <div
        class="container-contact-us"
        id="containerContact"
        name="containerContact"
        #containerContact
      >
        <div *ngIf="!showMessage">
          <h3 class="contactModule__form-title site__title">
            {{ "request-a-presentation.reques-a-presentation" | translate }}
          </h3>
          <h5 class="contactModule__form-title site__title">
            {{ "request-a-presentation.our-consultant" | translate }}
          </h5>
          <form (ngSubmit)="contactUs()" ngForm #form="ngForm" class="row">
            <div class="form-group">
              <label for="name">{{
                "request-a-presentation.firstName" | translate
              }}</label>
              <input
                type="text"
                id="name"
                name="name"
                class="form-control"
                [placeholder]="
                  'request-a-presentation.placeholder.firstName' | translate
                "
                (keydown)="space($event)"
                #name="ngModel"
                required
                [(ngModel)]="newContactInfo.name"
                (ngModelChange)="isNameValid($event)"
              />
              <div
                *ngIf="name.touched && nameValid != ''"
                class="invalid-input"
              >
                {{ nameValid | translate }}
              </div>
            </div>

            <div class="form-group">
              <label for="company">{{
                "request-a-presentation.company" | translate
              }}</label>
              <input
                type="text"
                id="company"
                name="company"
                class="form-control"
                [placeholder]="
                  'request-a-presentation.placeholder.company' | translate
                "
                (keydown)="space($event)"
                #company="ngModel"
                required
                [(ngModel)]="newContactInfo.company"
                (ngModelChange)="isCompanyValid($event)"
              />
              <div
                *ngIf="company.touched && companyValid != ''"
                class="invalid-input"
              >
                {{ companyValid | translate }}
              </div>
            </div>

            <div class="form-group">
              <label for="email">{{ "contactUs.email" | translate }}</label>
              <input
                type="text"
                id="email"
                name="email"
                class="form-control"
                [placeholder]="'contactUs.placeholder.email' | translate"
                (keydown)="space($event)"
                #email="ngModel"
                required
                [(ngModel)]="newContactInfo.email"
                (ngModelChange)="isEmailValid($event)"
              />
              <div
                *ngIf="email.touched && emailValid != ''"
                class="invalid-input"
              >
                {{ emailValid | translate }}
              </div>
            </div>

            <div class="form-group">
              <label for="phone">{{
                "request-a-presentation.phone" | translate
              }}</label>
              <input
                type="text"
                id="phone"
                name="phone"
                class="form-control"
                [placeholder]="
                  'request-a-presentation.placeholder.phone' | translate
                "
                (keydown)="space($event)"
                #phone="ngModel"
                required
                [(ngModel)]="newContactInfo.phone"
                (ngModelChange)="isPhoneValid($event)"
              />
              <div
                *ngIf="phone.touched && phoneValid != ''"
                class="invalid-input"
              >
                {{ phoneValid | translate }}
              </div>
            </div>

            <div class="submit">
              <button type="submit" class="btn button">
                {{ "request-a-presentation.button-konzultacia" | translate }}
              </button>
            </div>
            <div class="submit-text">
              {{ "request-a-presentation.free.consultation" | translate }}
            </div>
          </form>
        </div>
        <div class="thank_you_message" *ngIf="showMessage">
          <h4>
            {{ "request-a-presentation.thank" | translate }}
            <span> {{ "request-a-presentation.you" | translate }} </span>
          </h4>
          <h6>
            <ng-container
              *ngIf="newContactInfo.presentation === 'yes'; else defaultText"
            >
              {{ "request-a-presentation.forReachingOutYes" | translate }}
            </ng-container>
            <ng-template #defaultText>
              {{ "request-a-presentation.forReachingOut" | translate }}
            </ng-template>
            <br />
            {{ "request-a-presentation.teamReview" | translate }}
          </h6>
          <button (click)="redirectToHomePage()" class="btn button">
            {{ "contactUs.ok" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End form -->

<button
  *ngIf="showButton"
  (click)="scrollToTop()"
  style="position: fixed; bottom: 20px; right: 20px; z-index: 1000"
  class="scroll-to-top-btn"
>
  {{ "request-a-presentation.button" | translate }}
</button>

<!-- About -->
<section class="container-about">
  <div class="about-main">
    <div class="about-image">
      <img
        src="../../assets/images/icon-1.png"
        alt="Lightning"
        class="about-lightning"
      />
      <img
        src="../../assets/images/programmer.webp"
        alt="Co-funded by the European Union"
      />
      <div class="about-block">
        <h1>20 <br /></h1>
        <h4>{{ "request-a-presentation.about-block" | translate }}</h4>
      </div>
    </div>

    <div class="about-text">
      <h6>{{ "request-a-presentation.about-text-h1" | translate }}</h6>
      <h1>{{ "request-a-presentation.about-text-h2" | translate }}</h1>
      <p>{{ "request-a-presentation.about-text-p" | translate }}</p>

      <div class="columb2">
        <div class="about-icon-text">
          <div class="about-icon">
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="80" height="80" rx="40" fill="#038846" />
              <path
                d="M20 25.6665V38.9998C20 38.9998 20 45.6665 35.5556 45.6665C51.1111 45.6665 51.1111 38.9998 51.1111 38.9998V25.6665"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M35.5556 19C51.1111 19 51.1111 25.6667 51.1111 25.6667C51.1111 25.6667 51.1111 32.3333 35.5556 32.3333C20 32.3333 20 25.6667 20 25.6667C20 25.6667 20 19 35.5556 19Z"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M35.5556 59C20 59 20 52.3333 20 52.3333V39"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M53.3333 59C55.788 59 57.7778 57.0102 57.7778 54.5555C57.7778 52.1009 55.788 50.1111 53.3333 50.1111C52.5238 50.1111 51.7649 50.3275 51.1111 50.7057C49.7827 51.4742 48.8889 52.9104 48.8889 54.5555C48.8889 56.2006 49.7827 57.6369 51.1111 58.4053C51.7649 58.7835 52.5238 59 53.3333 59Z"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M53.3333 61.2222C57.0153 61.2222 60 58.2376 60 54.5556C60 50.8736 57.0153 47.8889 53.3333 47.8889C49.6513 47.8889 46.6667 50.8736 46.6667 54.5556C46.6667 58.2376 49.6513 61.2222 53.3333 61.2222Z"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-dasharray="2.13 14.2"
              />
            </svg>
          </div>
          <h5>{{ "request-a-presentation.about-text-h3" | translate }}</h5>
        </div>
        <div class="about-icon-text">
          <div class="about-icon">
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="80" height="80" rx="40" fill="#038846" />
              <path
                d="M60 19L57.7778 21.2222"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M20 19L22.2222 21.2222"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M60 50.1111L57.7778 47.8889"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M20 50.1111L22.2222 47.8889"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M33.3333 54.5557H46.6667"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M35.5555 61.2222H44.4444"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M39.9995 21.2222C31.1104 21.2222 26.5597 25.5561 26.6663 32.3333C26.7183 35.6375 27.7771 37.8888 29.9997 40.1111C32.2222 42.3333 33.3333 43.4444 33.333 47.8888H46.6662C46.6667 43.4446 47.7778 42.3333 49.9993 40.1113C52.2213 37.8891 53.2811 35.6375 53.3329 32.3333C53.4395 25.5561 48.8889 21.2222 39.9995 21.2222Z"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h5>
            VR/AR <br />
            {{ "request-a-presentation.about-text-h4" | translate }}
          </h5>
        </div>
      </div>
      <ul class="custom-list">
        <li>{{ "request-a-presentation.about-text-li1" | translate }}</li>
        <li>{{ "request-a-presentation.about-text-li2" | translate }}</li>
        <li>{{ "request-a-presentation.about-text-li3" | translate }}</li>
      </ul>
    </div>
  </div>
</section>
<!-- End About -->

<!-- OUR SERVICE -->
<section class="container-service">
  <div class="main-service">
    <div class="main-text-service">
      <h6>{{ "request-a-presentation.service-h1" | translate }}</h6>
      <h1>{{ "request-a-presentation.service-h2" | translate }}</h1>
      <p>
        {{ "request-a-presentation.service-p1" | translate }} <br /><br />
        {{ "request-a-presentation.service-p2" | translate }}
        <br /><br />
        {{ "request-a-presentation.service-p3" | translate }}
      </p>
    </div>
    <div class="service-icon">
      <div class="service-icon-separetly">
        <svg
          width="81"
          height="80"
          viewBox="0 0 81 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            width="80"
            height="80"
            rx="40"
            fill="#56CC9D"
            fill-opacity="0.1"
          />
          <path
            d="M56.4375 57.7422C56.4375 58.0547 56.3464 58.3216 56.1641 58.543C55.9818 58.7643 55.8516 58.875 55.7734 58.875H25.7344C25.4219 58.875 25.1549 58.7643 24.9336 58.543C24.7122 58.3216 24.6016 58.0547 24.6016 57.7422C24.6016 56.3099 24.862 54.9818 25.3828 53.7578C25.9297 52.5078 26.6654 51.4206 27.5898 50.4961C28.5143 49.5716 29.6016 48.8359 30.8516 48.2891C32.1016 47.7682 33.4297 47.5078 34.8359 47.5078H46.2031C47.6094 47.5078 48.9375 47.7682 50.1875 48.2891C51.4115 48.8359 52.4922 49.5716 53.4297 50.4961C54.3672 51.4206 55.0964 52.5078 55.6172 53.7578C56.1641 54.9818 56.4375 56.3099 56.4375 57.7422ZM49.6016 53.1719V56.6094H54.0547C53.7943 54.8385 53.0456 53.3346 51.8086 52.0977C50.5716 50.8607 49.0938 50.112 47.375 49.8516H47.3359V52.0391H48.4688C48.7812 52.0391 49.0482 52.1497 49.2695 52.3711C49.4909 52.5924 49.6016 52.8594 49.6016 53.1719ZM33.7031 49.8516C31.9583 50.112 30.4609 50.8607 29.2109 52.0977C27.9609 53.3346 27.2057 54.8125 26.9453 56.5312V56.6094H31.3984V53.1719C31.3984 52.8594 31.5091 52.5924 31.7305 52.3711C31.9518 52.1497 32.2188 52.0391 32.5312 52.0391H33.7031V49.8516ZM33.7031 55.0078V56.6094H47.3359V55.0078H33.7031ZM45.0703 49.7734H35.9688V52.0391H45.0703V49.7734ZM31.3984 38.4062V36.1406H30.2656C29.9531 36.1406 29.6862 36.0299 29.4648 35.8086C29.2435 35.5872 29.1328 35.3203 29.1328 35.0078V32.7812C29.1328 32 29.3737 31.3034 29.8555 30.6914C30.3372 30.0794 30.9297 29.6693 31.6328 29.4609L31.6719 29.4219C32.0365 27.9896 32.694 26.7266 33.6445 25.6328C34.5951 24.5391 35.7214 23.7188 37.0234 23.1719L37.1016 23.1328V21.1797C37.1016 20.9193 37.2122 20.6654 37.4336 20.418C37.6549 20.1706 37.9219 20.0469 38.2344 20.0469H42.7656C43.1042 20.0469 43.3841 20.1706 43.6055 20.418C43.8268 20.6654 43.9375 20.9193 43.9375 21.1797V23.1328C45.2656 23.7057 46.4115 24.5391 47.375 25.6328C48.3385 26.7266 48.9896 27.9766 49.3281 29.3828L49.3672 29.4219C50.0964 29.6562 50.6953 30.0794 51.1641 30.6914C51.6328 31.3034 51.8672 32 51.8672 32.7812V35.0078C51.8672 35.3203 51.7565 35.5872 51.5352 35.8086C51.3138 36.0299 51.0469 36.1406 50.7344 36.1406H49.6016V38.4062C49.6016 39.6562 49.3672 40.8281 48.8984 41.9219C48.4297 43.0417 47.8112 44.0117 47.043 44.832C46.2747 45.6523 45.4089 46.2969 44.4453 46.7656C43.4557 47.2604 42.4531 47.5078 41.4375 47.5078C39.9531 47.5078 38.599 47.2604 37.375 46.7656C36.151 46.2969 35.0964 45.6523 34.2109 44.832C33.3255 44.0117 32.6354 43.0417 32.1406 41.9219C31.6458 40.8281 31.3984 39.6562 31.3984 38.4062ZM49.6016 33.8359V32.7812C49.6016 32.4427 49.4844 32.1562 49.25 31.9219C49.0156 31.6875 48.7292 31.5703 48.3906 31.5703C48.1042 31.5703 47.8568 31.5703 47.6484 31.5703C47.4401 31.5703 47.3099 31.2448 47.2578 30.5938C47.388 29.5521 46.9388 28.4583 45.9102 27.3125C44.8815 26.1667 43.7292 25.4115 42.4531 25.0469C42.2188 24.9688 42.1667 24.832 42.2969 24.6367C42.4271 24.4414 42.4922 24.2135 42.4922 23.9531V22.3125H39.3672V23.9531C39.3672 24.2135 39.2956 24.4414 39.1523 24.6367C39.0091 24.832 38.8073 24.9688 38.5469 25.0469C37.2969 25.4115 36.2357 26.1667 35.3633 27.3125C34.4909 28.4583 33.9505 29.5521 33.7422 30.5938C33.7161 31.2448 33.6706 31.5703 33.6055 31.5703C33.5404 31.5703 33.2214 31.5703 32.6484 31.5703C32.3099 31.5703 32.0169 31.6875 31.7695 31.9219C31.5221 32.1562 31.3984 32.4427 31.3984 32.7812V33.8359H40.3438C40.4219 33.7839 40.2396 33.543 39.7969 33.1133C39.3542 32.6836 39.3281 32.2865 39.7188 31.9219L40.8516 30.75L37.7266 29.1875C37.388 29.0052 37.2188 28.7253 37.2188 28.3477C37.2188 27.9701 37.5573 27.638 38.2344 27.3516L39.7188 25.0859C40.2396 24.5651 40.7669 24.5716 41.3008 25.1055C41.8346 25.6393 41.8411 26.1667 41.3203 26.6875L40.1484 27.8594L43.2734 29.4219C43.4818 29.526 43.6445 29.6693 43.7617 29.8516C43.8789 30.0339 43.9375 30.2292 43.9375 30.4375C43.9375 30.5938 43.9049 30.7435 43.8398 30.8867C43.7747 31.0299 43.6901 31.1536 43.5859 31.2578L41.3203 33.5234C41.2422 33.6016 41.151 33.6667 41.0469 33.7188C40.9427 33.7708 40.8255 33.8099 40.6953 33.8359H49.6016ZM33.7031 38.4062C33.7031 40.2812 34.4062 41.8828 35.8125 43.2109C37.2188 44.5391 39.0938 45.2031 41.4375 45.2031C42.8438 45.2031 44.1784 44.5391 45.4414 43.2109C46.7044 41.8828 47.3359 40.2812 47.3359 38.4062V36.1406H33.7031V38.4062Z"
            fill="#038846"
          />
        </svg>
        <h6>{{ "request-a-presentation.service-icon" | translate }}</h6>
      </div>
      <div class="service-icon-separetly">
        <svg
          width="81"
          height="80"
          viewBox="0 0 81 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            width="80"
            height="80"
            rx="40"
            fill="#56CC9D"
            fill-opacity="0.1"
          />
          <path
            d="M58.9375 35.5156L53.4688 40.9844L54.2891 41.8047C54.3932 41.9089 54.4779 42.0326 54.543 42.1758C54.6081 42.319 54.6406 42.4688 54.6406 42.625C54.6406 42.7812 54.6081 42.9245 54.543 43.0547C54.4779 43.1849 54.3932 43.3021 54.2891 43.4062L49.6797 48.0156C48.8984 49.2396 47.5833 50.0924 45.7344 50.5742C43.8854 51.056 42.1276 51.1406 40.4609 50.8281C39.4974 50.6198 38.651 50.6133 37.9219 50.8086C37.1927 51.0039 36.4375 51.349 35.6562 51.8438L32.4531 54.3438C32.1667 54.5521 31.8477 54.7214 31.4961 54.8516C31.1445 54.9818 30.7604 55.0469 30.3438 55.0469C29.875 55.0469 29.4323 54.9557 29.0156 54.7734C28.599 54.5911 28.2474 54.3568 27.9609 54.0703L28.4297 53.875L23.0781 59.1484C23.2344 59.0703 23.0586 59.0312 22.5508 59.0312C22.043 59.0312 21.6849 59.0703 21.4766 59.1484C21.2422 58.6276 21.125 58.1849 21.125 57.8203C21.125 57.4557 21.2422 57.1562 21.4766 56.9219L26.1641 52.2734L25.9688 52.0781C25.3438 51.4531 25.0508 50.7109 25.0898 49.8516C25.1289 48.9922 25.474 48.224 26.125 47.5469L28.1562 44.3828C28.6771 43.7318 29.0286 43.0026 29.2109 42.1953C29.3932 41.388 29.3932 40.5156 29.2109 39.5781C29.1589 39.2656 29.1133 38.9336 29.0742 38.582C29.0352 38.2305 29.0156 37.8854 29.0156 37.5469C29.0156 36.1406 29.2826 34.8125 29.8164 33.5625C30.3503 32.3125 31.0729 31.2318 31.9844 30.3203L36.5938 26.3359C36.8281 25.8151 37.1016 25.5547 37.4141 25.5547C37.7266 25.5547 37.987 25.8151 38.1953 26.3359L39.4844 26.5312L44.4844 21.0625C45.1354 20.3854 45.9688 20.0469 46.9844 20.0469C48 20.0469 49.0286 20.3854 50.0703 21.0625C50.3568 21.7135 50.5 22.5143 50.5 23.4648C50.5 24.4154 50.3568 25.2161 50.0703 25.8672L43.8203 31.3359L48.6641 36.1797L54.1328 30.7109C55.2005 30.0339 56.1055 29.6953 56.8477 29.6953C57.5898 29.6953 58.2865 30.0339 58.9375 30.7109C59.25 31.0234 59.4974 31.388 59.6797 31.8047C59.862 32.2214 59.9531 32.6641 59.9531 33.1328C59.9531 33.6016 59.862 34.0443 59.6797 34.4609C59.4974 34.8776 59.25 35.2292 58.9375 35.5156ZM27.4922 48.9531C27.4141 49.0573 27.349 49.168 27.2969 49.2852C27.2448 49.4023 27.2188 49.526 27.2188 49.6562C27.2188 49.8125 27.2513 49.9622 27.3164 50.1055C27.3815 50.2487 27.4661 50.3724 27.5703 50.4766L29.5625 52.4297C29.6667 52.5339 29.7839 52.6185 29.9141 52.6836C30.0443 52.7487 30.1875 52.7812 30.3438 52.7812C30.474 52.7812 30.6042 52.7617 30.7344 52.7227C30.8646 52.6836 30.9688 52.625 31.0469 52.5469L34.2891 50.9844L29.6797 46.1406L27.4922 48.9531ZM47.6875 24.2656C47.9219 24.0573 48.0391 23.8294 48.0391 23.582C48.0391 23.3346 47.9219 23.2891 47.6875 23.4453C47.8698 22.8464 47.707 22.5469 47.1992 22.5469C46.6914 22.5469 46.3203 22.8464 46.0859 23.4453L40.6172 28.1328L42.2188 29.7344L47.6875 24.2656ZM37.4141 28.1328L33.625 31.9219C32.8958 32.651 32.3229 33.4974 31.9062 34.4609C31.4896 35.4245 31.2812 36.4531 31.2812 37.5469C31.2812 37.8073 31.2943 38.0742 31.3203 38.3477C31.3464 38.6211 31.3984 38.888 31.4766 39.1484L31.4375 39.1094C31.6719 39.9688 31.737 40.8346 31.6328 41.707C31.5286 42.5794 31.2943 43.5495 30.9297 44.6172L35.8516 49.1094C36.6849 48.7188 37.5182 48.5039 38.3516 48.4648C39.1849 48.4258 40.0312 48.4583 40.8906 48.5625C42.1927 48.8229 43.5469 48.8424 44.9531 48.6211C46.3594 48.3997 47.401 47.6641 48.0781 46.4141L51.8672 42.625L37.4141 28.1328ZM57.3359 32.3125C57.2318 32.3385 57.1081 32.3581 56.9648 32.3711C56.8216 32.3841 56.6849 32.3906 56.5547 32.3906C56.3984 32.3906 56.2552 32.3841 56.125 32.3711C55.9948 32.3581 55.8516 32.3385 55.6953 32.3125H55.7344L50.5 37.7812L51.8672 39.3828L57.3359 34.5C57.5703 33.9792 57.6875 33.543 57.6875 33.1914C57.6875 32.8398 57.5703 32.5469 57.3359 32.3125ZM38.1953 41.8047C37.5443 41.1276 37.2188 40.3333 37.2188 39.4219C37.2188 38.5104 37.5443 37.8203 38.1953 37.3516C38.8724 36.4922 39.6797 36.0625 40.6172 36.0625C41.5547 36.0625 42.362 36.4922 43.0391 37.3516C43.6901 37.8203 44.0156 38.5104 44.0156 39.4219C44.0156 40.3333 43.6901 41.1276 43.0391 41.8047C42.362 42.6901 41.5547 43.1328 40.6172 43.1328C39.6797 43.1328 38.8724 42.6901 38.1953 41.8047ZM41.4375 38.6016C41.3333 38.4974 41.2096 38.4128 41.0664 38.3477C40.9232 38.2826 40.7734 38.25 40.6172 38.25C40.4609 38.25 40.3112 38.2826 40.168 38.3477C40.0247 38.4128 39.9141 38.4974 39.8359 38.6016C39.6016 39.0182 39.4844 39.3307 39.4844 39.5391C39.4844 39.7474 39.6016 39.9688 39.8359 40.2031C39.9141 40.3073 40.0247 40.3854 40.168 40.4375C40.3112 40.4896 40.4609 40.5156 40.6172 40.5156C40.7734 40.5156 40.9232 40.4896 41.0664 40.4375C41.2096 40.3854 41.3333 40.3073 41.4375 40.2031C41.6458 39.9688 41.75 39.7474 41.75 39.5391C41.75 39.3307 41.6458 39.0182 41.4375 38.6016Z"
            fill="#038846"
          />
        </svg>
        <h6>{{ "request-a-presentation.service-icon-2" | translate }}</h6>
      </div>
      <div class="service-icon-separetly">
        <svg
          width="81"
          height="80"
          viewBox="0 0 81 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            width="80"
            height="80"
            rx="40"
            fill="#56CC9D"
            fill-opacity="0.1"
          />
          <path
            d="M48.8594 58.7578C47.5833 58.7578 46.3659 58.5365 45.207 58.0938C44.0482 57.651 43 57.0911 42.0625 56.4141H22.1797C21.8672 56.4141 21.6003 56.2773 21.3789 56.0039C21.1576 55.7305 21.0469 55.4375 21.0469 55.125V21.1797C21.0469 20.8672 21.1576 20.6003 21.3789 20.3789C21.6003 20.1576 21.8672 20.0469 22.1797 20.0469H46.5547C46.8151 20.0469 47.1471 20.1576 47.5508 20.3789C47.9544 20.6003 48.1562 20.8672 48.1562 21.1797V37.1172C49.7448 36.9349 51.2422 37.0911 52.6484 37.5859C54.0547 38.0807 55.2852 38.8229 56.3398 39.8125C57.3945 40.8021 58.2344 41.987 58.8594 43.3672C59.4583 44.7734 59.7578 46.2708 59.7578 47.8594C59.7578 49.3698 59.4714 50.776 58.8984 52.0781C58.3255 53.4062 57.5443 54.5651 56.5547 55.5547C55.5651 56.5443 54.4062 57.3255 53.0781 57.8984C51.776 58.4714 50.3698 58.7578 48.8594 58.7578ZM45.3047 22.3125H23.3125V53.9922H40.8125C39.5885 52.5339 38.8203 50.9714 38.5078 49.3047C38.1953 47.6641 38.2604 46.0755 38.7031 44.5391C39.1458 43.0026 39.9401 41.6224 41.0859 40.3984C42.2057 39.1745 43.612 38.263 45.3047 37.6641V22.3125ZM48.8594 39.3438C47.6875 39.3438 46.5807 39.5651 45.5391 40.0078C44.5234 40.4505 43.625 41.056 42.8438 41.8242C42.0625 42.5924 41.4505 43.4974 41.0078 44.5391C40.5651 45.5807 40.3438 46.6875 40.3438 47.8594C40.3438 49.0573 40.5651 50.1771 41.0078 51.2188C41.4505 52.2604 42.0625 53.1719 42.8438 53.9531C43.625 54.7344 44.5234 55.3594 45.5391 55.8281C46.5807 56.2708 47.6875 56.4922 48.8594 56.4922C50.0573 56.4922 51.1771 56.2708 52.2188 55.8281C53.2344 55.3594 54.1328 54.7344 54.9141 53.9531C55.6953 53.1719 56.3073 52.2604 56.75 51.2188C57.1927 50.1771 57.4141 49.0573 57.4141 47.8594C57.4141 46.6875 57.1927 45.5807 56.75 44.5391C56.3073 43.4974 55.6953 42.5924 54.9141 41.8242C54.1328 41.056 53.2344 40.4505 52.2188 40.0078C51.1771 39.5651 50.0573 39.3438 48.8594 39.3438ZM50.1484 46.7656C51.6328 47.2865 52.3229 48.2956 52.2188 49.793C52.1146 51.2904 51.3854 52.2865 50.0312 52.7812V53.1328C50.0312 53.3932 49.9206 53.7318 49.6992 54.1484C49.4779 54.5651 49.2109 54.7734 48.8984 54.7734C48.5599 54.7734 48.2799 54.5651 48.0586 54.1484C47.8372 53.7318 47.7266 53.3932 47.7266 53.1328V52.8984C47.4661 52.8724 47.2122 52.8073 46.9648 52.7031C46.7174 52.599 46.4375 52.4427 46.125 52.2344C45.8646 52.0521 45.8255 51.8112 46.0078 51.5117C46.1901 51.2122 46.125 50.9323 45.8125 50.6719C45.9167 50.5156 46.0534 50.3919 46.2227 50.3008C46.3919 50.2096 46.5677 50.1641 46.75 50.1641C46.8802 50.1641 46.9974 50.1771 47.1016 50.2031C47.2057 50.2292 47.2969 50.2682 47.375 50.3203C47.6615 50.5026 47.8893 50.6133 48.0586 50.6523C48.2279 50.6914 48.4948 50.7109 48.8594 50.7109C49.224 50.7109 49.4909 50.6133 49.6602 50.418C49.8294 50.2227 49.9271 50.125 49.9531 50.125C49.9792 49.8125 49.9596 49.5521 49.8945 49.3438C49.8294 49.1354 49.6536 48.9922 49.3672 48.9141C48.8984 48.7318 48.4362 48.556 47.9805 48.3867C47.5247 48.2174 47.1276 48.0938 46.7891 48.0156C46.0078 47.2083 45.7148 46.2448 45.9102 45.125C46.1055 44.0052 46.7109 43.263 47.7266 42.8984V42.7422C47.7266 42.7161 47.7266 42.7031 47.7266 42.7031C47.7266 42.3906 47.8372 42.1237 48.0586 41.9023C48.2799 41.681 48.5599 41.5703 48.8984 41.5703C49.2109 41.5703 49.4779 41.681 49.6992 41.9023C49.9206 42.1237 50.0312 42.3906 50.0312 42.7031C50.0312 42.7031 50.0312 42.7161 50.0312 42.7422V42.7812C50.2917 42.8594 50.5326 42.9701 50.7539 43.1133C50.9753 43.2565 51.1641 43.4062 51.3203 43.5625C51.4245 43.6667 51.5091 43.7839 51.5742 43.9141C51.6393 44.0443 51.6719 44.1875 51.6719 44.3438C51.6719 44.5 51.6393 44.6497 51.5742 44.793C51.5091 44.9362 51.4245 45.0599 51.3203 45.1641C51.5547 45.3724 51.4115 45.4766 50.8906 45.4766C50.3698 45.4766 50.0573 45.3594 49.9531 45.125C49.7969 45.099 49.6146 45.0469 49.4062 44.9688C49.1979 44.8906 48.9115 44.9036 48.5469 45.0078C48.3906 45.0599 48.2865 45.1706 48.2344 45.3398C48.1823 45.5091 48.1562 45.763 48.1562 46.1016C48.1302 45.8932 48.1237 45.7956 48.1367 45.8086C48.1497 45.8216 48.1693 45.8411 48.1953 45.8672C48.8203 46.0234 49.2109 46.1797 49.3672 46.3359C49.5234 46.4922 49.7839 46.6354 50.1484 46.7656ZM39.7969 38.1328C39.4844 38.1328 39.2174 38.0221 38.9961 37.8008C38.7747 37.5794 38.6641 37.3125 38.6641 37C38.6641 36.6875 38.7747 36.4206 38.9961 36.1992C39.2174 35.9779 39.4844 35.8672 39.7969 35.8672H41.0078C41.3203 35.8672 41.6263 35.9779 41.9258 36.1992C42.2253 36.4206 42.375 36.6875 42.375 37C42.375 37.3125 42.2253 37.5794 41.9258 37.8008C41.6263 38.0221 41.3203 38.1328 41.0078 38.1328H39.7969ZM28.0391 33.2891C27.2578 33.2891 26.7956 33.1784 26.6523 32.957C26.5091 32.7357 26.4375 32.4688 26.4375 32.1562V27.0391C26.4375 26.2578 26.5091 25.7891 26.6523 25.6328C26.7956 25.4766 27.2578 25.3984 28.0391 25.3984H41.6328C41.9453 25.3984 42.2122 25.4766 42.4336 25.6328C42.6549 25.7891 42.7656 26.2578 42.7656 27.0391V32.1562C42.7656 32.4688 42.6549 32.7357 42.4336 32.957C42.2122 33.1784 41.9453 33.2891 41.6328 33.2891H28.0391ZM40.5 27.2344H28.2344V31.0234H40.5V27.2344ZM27.6875 35.8672H28.8984C29.2109 35.8672 29.4714 35.9779 29.6797 36.1992C29.888 36.4206 29.9922 36.6875 29.9922 37C29.9922 37.2865 29.888 37.5404 29.6797 37.7617C29.4714 37.9831 29.2109 38.1068 28.8984 38.1328H27.6875C27.7656 38.1328 27.5964 38.0221 27.1797 37.8008C26.763 37.5794 26.5547 37.3125 26.5547 37C26.5547 36.6875 26.763 36.4206 27.1797 36.1992C27.5964 35.9779 27.7656 35.8672 27.6875 35.8672ZM27.6875 41.8828H28.8984C29.2109 41.9089 29.4714 42.0326 29.6797 42.2539C29.888 42.4753 29.9922 42.7292 29.9922 43.0156C29.9922 43.3281 29.888 43.5951 29.6797 43.8164C29.4714 44.0378 29.2109 44.1615 28.8984 44.1875H27.6875C27.7656 44.1875 27.5964 44.0768 27.1797 43.8555C26.763 43.6341 26.5547 43.3542 26.5547 43.0156C26.5547 42.7031 26.763 42.4362 27.1797 42.2148C27.5964 41.9935 27.7656 41.8828 27.6875 41.8828ZM27.6875 47.9375H28.8984C29.2109 47.9635 29.4714 48.0872 29.6797 48.3086C29.888 48.5299 29.9922 48.7839 29.9922 49.0703C29.9922 49.3828 29.888 49.6497 29.6797 49.8711C29.4714 50.0924 29.2109 50.2031 28.8984 50.2031H27.6875C27.7656 50.2031 27.5964 50.0924 27.1797 49.8711C26.763 49.6497 26.5547 49.3828 26.5547 49.0703C26.5547 48.7578 26.763 48.4909 27.1797 48.2695C27.5964 48.0482 27.7656 47.9375 27.6875 47.9375ZM33.7422 35.8672H34.9531C34.9531 35.8672 34.9596 35.8607 34.9727 35.8477C34.9857 35.8346 34.9922 35.8281 34.9922 35.8281C35.3047 35.8281 35.5716 35.9453 35.793 36.1797C36.0143 36.4141 36.125 36.6875 36.125 37C36.125 37.3125 36.0143 37.5794 35.793 37.8008C35.5716 38.0221 35.3047 38.1328 34.9922 38.1328C34.9922 38.1328 34.9857 38.1328 34.9727 38.1328C34.9596 38.1328 34.9531 38.1328 34.9531 38.1328H33.7422C33.4297 38.1328 33.1628 38.0221 32.9414 37.8008C32.7201 37.5794 32.6094 37.3125 32.6094 37C32.6094 36.6875 32.7201 36.4206 32.9414 36.1992C33.1628 35.9779 33.4297 35.8672 33.7422 35.8672ZM33.7422 41.8828H34.9531C34.9531 41.8828 34.9596 41.8828 34.9727 41.8828C34.9857 41.8828 34.9922 41.8828 34.9922 41.8828C35.3047 41.8828 35.5716 41.9935 35.793 42.2148C36.0143 42.4362 36.125 42.7031 36.125 43.0156C36.125 43.3542 36.0143 43.6341 35.793 43.8555C35.5716 44.0768 35.3047 44.1875 34.9922 44.1875C34.9922 44.1875 34.9857 44.1875 34.9727 44.1875C34.9596 44.1875 34.9531 44.1875 34.9531 44.1875H33.7422C33.7422 44.1875 33.7292 44.1875 33.7031 44.1875C33.3906 44.1875 33.1237 44.0768 32.9023 43.8555C32.681 43.6341 32.5703 43.3542 32.5703 43.0156C32.5703 42.7031 32.681 42.4362 32.9023 42.2148C33.1237 41.9935 33.3906 41.8828 33.7031 41.8828C33.7292 41.8828 33.7422 41.8828 33.7422 41.8828ZM33.7422 47.9375H34.9531C34.9531 47.9375 34.9596 47.9375 34.9727 47.9375C34.9857 47.9375 34.9922 47.9375 34.9922 47.9375C35.3047 47.9375 35.5716 48.0482 35.793 48.2695C36.0143 48.4909 36.125 48.7578 36.125 49.0703C36.125 49.3828 36.0143 49.6497 35.793 49.8711C35.5716 50.0924 35.3047 50.2031 34.9922 50.2031C34.9922 50.2031 34.9857 50.2031 34.9727 50.2031C34.9596 50.2031 34.9531 50.2031 34.9531 50.2031H33.7422C33.7422 50.2031 33.7292 50.2031 33.7031 50.2031C33.3906 50.2031 33.1237 50.0924 32.9023 49.8711C32.681 49.6497 32.5703 49.3828 32.5703 49.0703C32.5703 48.7578 32.681 48.4909 32.9023 48.2695C33.1237 48.0482 33.3906 47.9375 33.7031 47.9375C33.7292 47.9375 33.7422 47.9375 33.7422 47.9375Z"
            fill="#038846"
          />
        </svg>
        <h6>{{ "request-a-presentation.service-icon-3" | translate }}</h6>
      </div>
      <div class="service-icon-separetly">
        <svg
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="80"
            height="80"
            rx="40"
            fill="#56CC9D"
            fill-opacity="0.1"
          />
          <path
            d="M56.2109 52.1172C55.3516 52.3776 54.3815 52.5794 53.3008 52.7227C52.2201 52.8659 51.0938 52.9375 49.9219 52.9375C47.7604 52.9375 45.7227 52.6901 43.8086 52.1953C41.8945 51.7005 40.8333 50.9193 40.625 49.8516C39.8177 49.8516 38.9844 49.8255 38.125 49.7734C37.2656 49.7214 36.5365 49.7474 35.9375 49.8516C35 50.2422 34.0234 50.5938 33.0078 50.9062C31.9922 51.2188 30.9635 51.375 29.9219 51.375C28.6458 51.375 27.4479 51.1276 26.3281 50.6328C25.2344 50.1641 24.2708 49.513 23.4375 48.6797C22.6042 47.8464 21.9401 46.8698 21.4453 45.75C20.9766 44.6562 20.7422 43.4714 20.7422 42.1953C20.7422 41.9089 20.7943 41.6224 20.8984 41.3359C21.0026 41.0495 21.0026 40.763 20.8984 40.4766C21.1328 39.2526 21.5885 38.1328 22.2656 37.1172C22.9427 36.1016 23.7695 35.2682 24.7461 34.6172C25.7227 33.9661 26.8099 33.5104 28.0078 33.25C29.1797 32.9896 30.3906 32.9766 31.6406 33.2109L31.5625 29.8125C31.5365 29.7344 31.5234 29.6693 31.5234 29.6172C31.5234 29.5651 31.5234 29.513 31.5234 29.4609C31.5234 28.7839 31.862 28.237 32.5391 27.8203C33.2161 27.4036 33.8932 27.0781 34.5703 26.8438C35.4297 26.5833 36.3997 26.388 37.4805 26.2578C38.5612 26.1276 39.6875 26.0625 40.8594 26.0625C42.0573 26.0625 43.2031 26.1276 44.2969 26.2578C45.3906 26.388 46.3672 26.5833 47.2266 26.8438C48.112 27.3646 48.8086 27.7422 49.3164 27.9766C49.8242 28.2109 50.1432 28.5495 50.2734 28.9922C50.3255 29.0703 50.3646 29.1484 50.3906 29.2266C50.4167 29.3047 50.4297 29.3828 50.4297 29.4609V37.625C51.5234 37.651 52.6237 37.7357 53.7305 37.8789C54.8372 38.0221 55.7552 38.2109 56.4844 38.4453C57.2656 38.7318 57.8971 39.0703 58.3789 39.4609C58.8607 39.8516 59.1406 40.2943 59.2188 40.7891C59.401 40.8411 59.5312 40.8932 59.6094 40.9453C59.6875 40.9974 59.7266 41.0495 59.7266 41.1016V49.5C59.7266 50.2552 59.3164 50.8672 58.4961 51.3359C57.6758 51.8047 56.9141 52.0651 56.2109 52.1172ZM40.5859 48.3281L40.5469 45.7109V45.5938C40.1823 45.5938 39.8307 45.5807 39.4922 45.5547C39.1536 45.5286 38.8151 45.5026 38.4766 45.4766C38.2943 45.9714 38.0794 46.4271 37.832 46.8438C37.5846 47.2604 37.3047 47.651 36.9922 48.0156H37.0312C37.6042 48.0938 38.1901 48.1654 38.7891 48.2305C39.388 48.2956 39.987 48.3281 40.5859 48.3281ZM38.9062 43.9922C39.1667 43.9922 39.4271 43.9987 39.6875 44.0117C39.9479 44.0247 40.2214 44.0312 40.5078 44.0312L41.0547 41.375C41.0547 41.375 41.0482 41.3685 41.0352 41.3555C41.0221 41.3424 41.0156 41.3359 41.0156 41.3359C40.4948 41.3359 40.0977 41.3294 39.8242 41.3164C39.5508 41.3034 39.2969 41.2969 39.0625 41.2969C39.0625 41.4531 39.069 41.6029 39.082 41.7461C39.0951 41.8893 39.1016 42.0391 39.1016 42.1953C39.1016 42.4818 39.0885 42.7747 39.0625 43.0742C39.0365 43.3737 38.9844 43.6797 38.9062 43.9922ZM32.1875 34.8906C31.849 34.7865 31.4844 34.7083 31.0938 34.6562C30.7031 34.6042 30.3125 34.5781 29.9219 34.5781C28.9583 34.5781 28.0599 34.7474 27.2266 35.0859C26.3932 35.4245 25.7682 35.9193 25.3516 36.5703C24.4141 37.2734 23.6979 38.0807 23.2031 38.9922C22.7083 39.9036 22.4219 40.8477 22.3438 41.8242C22.2656 42.8008 22.3828 43.7708 22.6953 44.7344C23.0339 45.6979 23.5547 46.5703 24.2578 47.3516C25.8724 48.888 27.6888 49.7083 29.707 49.8125C31.7253 49.9167 33.5156 49.2526 35.0781 47.8203C35.8333 47.1432 36.4388 46.3164 36.8945 45.3398C37.3503 44.3633 37.5781 43.3151 37.5781 42.1953C37.5781 41.9349 37.5651 41.6745 37.5391 41.4141C37.513 41.1536 37.474 40.8932 37.4219 40.6328C37.1354 39.2786 36.5234 38.0938 35.5859 37.0781C34.6484 36.0625 33.5286 35.3464 32.2266 34.9297L32.1875 34.8906ZM46.7969 28.3281C46.0156 28.0938 45.1107 27.9115 44.082 27.7812C43.0534 27.651 41.9792 27.5859 40.8594 27.5859C39.7656 27.5859 38.7174 27.651 37.7148 27.7812C36.7122 27.9115 35.8203 28.0938 35.0391 28.3281C34.2318 28.5625 33.7044 28.7969 33.457 29.0312C33.2096 29.2656 33.0729 29.4089 33.0469 29.4609C33.0729 29.4609 33.0859 29.4609 33.0859 29.4609C33.0859 29.5651 33.2357 29.7279 33.5352 29.9492C33.8346 30.1706 34.401 30.3984 35.2344 30.6328C35.9896 30.8672 36.8555 31.1471 37.832 31.4727C38.8086 31.7982 39.8177 31.9609 40.8594 31.9609C41.9792 31.9609 43.0534 31.7917 44.082 31.4531C45.1107 31.1146 46.0026 30.8281 46.7578 30.5938C47.6172 30.3333 48.1706 30.0924 48.418 29.8711C48.6654 29.6497 48.7891 29.513 48.7891 29.4609C48.7891 29.4089 48.6654 29.2721 48.418 29.0508C48.1706 28.8294 47.6302 28.5885 46.7969 28.3281ZM48.9062 31.375C48.6458 31.5052 48.3724 31.6289 48.0859 31.7461C47.7995 31.8633 47.513 31.9609 47.2266 32.0391C46.263 32.3255 45.2474 32.5534 44.1797 32.7227C43.112 32.8919 42.0052 32.9766 40.8594 32.9766C39.7396 32.9766 38.6523 32.9115 37.5977 32.7812C36.543 32.651 35.599 32.599 34.7656 32.625C34.4792 32.2865 34.1992 32.0456 33.9258 31.9023C33.6523 31.7591 33.3854 31.6094 33.125 31.4531L33.1641 33.7188C33.6068 33.849 34.0299 34.0312 34.4336 34.2656C34.8372 34.5 35.2214 34.7344 35.5859 34.9688C35.5859 34.9948 35.5924 35.0078 35.6055 35.0078C35.6185 35.0078 35.625 35.0078 35.625 35.0078C36.3802 35.1901 37.207 35.3268 38.1055 35.418C39.0039 35.5091 39.9219 35.5547 40.8594 35.5547C41.9531 35.5547 43.0208 35.4896 44.0625 35.3594C45.1042 35.2292 46.0026 35.0469 46.7578 34.8125C47.6172 34.5781 48.1706 34.3438 48.418 34.1094C48.6654 33.875 48.7891 33.7318 48.7891 33.6797C48.7891 33.6016 48.8021 33.5365 48.8281 33.4844C48.8542 33.4323 48.8802 33.3802 48.9062 33.3281V31.375ZM48.9062 35.6328C48.6458 35.763 48.3724 35.8867 48.0859 36.0039C47.7995 36.1211 47.513 36.2188 47.2266 36.2969C46.3672 36.8958 45.3906 37.1823 44.2969 37.1562C43.2031 37.1302 42.0573 37.1172 40.8594 37.1172C40.2865 37.1172 39.707 37.0977 39.1211 37.0586C38.5352 37.0195 37.9557 36.9609 37.3828 36.8828C37.6953 37.2995 37.9622 37.7422 38.1836 38.2109C38.4049 38.6797 38.5938 39.1615 38.75 39.6562V39.7344C39.0885 39.7604 39.4336 39.7799 39.7852 39.793C40.1367 39.806 40.4948 39.8125 40.8594 39.8125H40.9375C41.5625 39.1094 42.6367 38.582 44.1602 38.2305C45.6836 37.8789 47.2656 37.6901 48.9062 37.6641V35.6328ZM58.2422 41.0234C58.138 40.9714 57.8906 40.8411 57.5 40.6328C57.1094 40.4245 56.4974 40.2552 55.6641 40.125C54.8828 39.7865 53.9779 39.5456 52.9492 39.4023C51.9206 39.2591 50.8594 39.1875 49.7656 39.1875H49.6875C48.6458 39.1875 47.6562 39.2461 46.7188 39.3633C45.7812 39.4805 44.9349 39.6432 44.1797 39.8516C43.3984 40.0599 42.8516 40.2747 42.5391 40.4961C42.2266 40.7174 42.0703 40.8802 42.0703 40.9844C42.1484 41.0104 42.207 41.0365 42.2461 41.0625C42.2852 41.0885 42.3307 41.1146 42.3828 41.1406C42.2526 41.2448 42.3372 41.401 42.6367 41.6094C42.9362 41.8177 43.4635 42.026 44.2188 42.2344C44.974 42.4427 45.8268 42.6055 46.7773 42.7227C47.7279 42.8398 48.724 42.8984 49.7656 42.8984C50.8594 42.8984 51.9141 42.8398 52.9297 42.7227C53.9453 42.6055 54.8438 42.4297 55.625 42.1953C56.4583 41.9349 57.0964 41.6875 57.5391 41.4531C57.9818 41.2188 58.2161 41.0755 58.2422 41.0234ZM58.3984 44.9297V42.9766C57.7995 43.1068 57.3307 43.2305 56.9922 43.3477C56.6536 43.4648 56.3281 43.5625 56.0156 43.6406C55.1562 43.901 54.1927 44.0964 53.125 44.2266C52.0573 44.3568 50.9375 44.4219 49.7656 44.4219C48.6458 44.4219 47.5716 44.3633 46.543 44.2461C45.5143 44.1289 44.5964 43.9531 43.7891 43.7188C43.4766 43.6406 43.1966 43.5495 42.9492 43.4453C42.7018 43.3411 42.5911 43.263 42.6172 43.2109L42.0703 44.8125V46.1406C42.3828 46.3229 43.2161 46.5378 44.5703 46.7852C45.9245 47.0326 47.6562 47.1562 49.7656 47.1562C50.8854 47.1562 51.9466 47.0911 52.9492 46.9609C53.9518 46.8307 54.8568 46.6484 55.6641 46.4141C56.4974 46.1536 57.0638 45.9128 57.3633 45.6914C57.6628 45.4701 57.8125 45.3333 57.8125 45.2812C57.8125 45.2292 57.7995 45.1706 57.7734 45.1055C57.7474 45.0404 57.7344 44.9818 57.7344 44.9297H58.3984ZM57.7344 47.1953C57.474 47.3255 57.2135 47.4492 56.9531 47.5664C56.6927 47.6836 56.4583 47.7812 56.25 47.8594C55.3125 48.1198 54.2969 48.3216 53.2031 48.4648C52.1094 48.6081 50.9635 48.6797 49.7656 48.6797C48.3594 48.6797 46.9596 48.569 45.5664 48.3477C44.1732 48.1263 43.0208 47.7812 42.1094 47.3125L42.1484 49.5391C42.1484 49.6172 42.2721 49.7669 42.5195 49.9883C42.7669 50.2096 43.2943 50.4375 44.1016 50.6719C44.8568 50.9062 45.7357 51.0885 46.7383 51.2188C47.7409 51.349 48.8021 51.4141 49.9219 51.4141C51.0156 51.4141 52.0703 51.349 53.0859 51.2188C54.1016 51.0885 54.987 50.9062 55.7422 50.6719C56.5755 50.6979 57.1159 50.5221 57.3633 50.1445C57.6107 49.7669 57.7344 49.5521 57.7344 49.5V47.1953ZM32.7734 45.8281C32.7995 45.8281 32.8385 45.8216 32.8906 45.8086C32.9427 45.7956 32.9818 45.7891 33.0078 45.7891C33.1901 45.7891 33.3464 45.8346 33.4766 45.9258C33.6068 46.0169 33.6979 46.1406 33.75 46.2969C33.776 46.3229 33.7891 46.362 33.7891 46.4141C33.7891 46.4661 33.7891 46.5182 33.7891 46.5703C33.7891 46.7266 33.7435 46.8698 33.6523 47C33.5612 47.1302 33.4505 47.2214 33.3203 47.2734C33.0078 47.3776 32.6888 47.4622 32.3633 47.5273C32.0378 47.5924 31.6927 47.625 31.3281 47.625C30.599 47.625 29.9023 47.4818 29.2383 47.1953C28.5742 46.9089 27.9948 46.5182 27.5 46.0234C27.2396 45.7891 27.0182 45.5156 26.8359 45.2031C26.6536 44.8906 26.5625 44.5781 26.5625 44.2656H25.1172C25.0391 44.2656 24.8958 44.1875 24.6875 44.0312C24.4792 43.875 24.375 43.6927 24.375 43.4844C24.375 43.4062 24.4792 43.2565 24.6875 43.0352C24.8958 42.8138 25.0391 42.7031 25.1172 42.7031H25.8984C25.8984 42.625 25.8984 42.5469 25.8984 42.4688C25.8984 42.3906 25.8984 42.2995 25.8984 42.1953C25.8984 42.1432 25.8984 42.0911 25.8984 42.0391C25.8984 41.987 25.8984 41.9219 25.8984 41.8438V41.8828H25.1172C25.0391 41.8828 24.8958 41.8828 24.6875 41.8828C24.4792 41.8828 24.375 41.6224 24.375 41.1016C24.375 40.9453 24.4792 40.7826 24.6875 40.6133C24.8958 40.444 25.0391 40.3594 25.1172 40.3594H26.2109C26.3411 39.9688 26.5169 39.6237 26.7383 39.3242C26.9596 39.0247 27.2135 38.8229 27.5 38.7188C28.2552 37.7812 29.1602 37.1823 30.2148 36.9219C31.2695 36.6615 32.3047 36.7266 33.3203 37.1172C33.4505 37.1693 33.5612 37.2604 33.6523 37.3906C33.7435 37.5208 33.7891 37.6771 33.7891 37.8594C33.7891 38.0677 33.7174 38.2435 33.5742 38.3867C33.431 38.5299 33.2422 38.6016 33.0078 38.6016C32.9818 38.6016 32.9427 38.5951 32.8906 38.582C32.8385 38.569 32.7865 38.5625 32.7344 38.5625C32.0312 38.276 31.3021 38.237 30.5469 38.4453C29.7917 38.6536 29.1406 38.9792 28.5938 39.4219C28.4635 39.5781 28.3659 39.7279 28.3008 39.8711C28.2357 40.0143 28.2943 40.1641 28.4766 40.3203H32.3828C32.5911 40.3203 32.7734 40.444 32.9297 40.6914C33.0859 40.9388 33.1641 41.0755 33.1641 41.1016C33.1641 41.5964 33.0859 41.8503 32.9297 41.8633C32.7734 41.8763 32.5911 41.8828 32.3828 41.8828H27.4609C27.4349 42.013 27.4284 42.1497 27.4414 42.293C27.4544 42.4362 27.4609 42.5729 27.4609 42.7031H31.9922C32.2005 42.7031 32.3763 42.8073 32.5195 43.0156C32.6628 43.224 32.7344 43.3802 32.7344 43.4844C32.7344 43.6927 32.6628 43.8685 32.5195 44.0117C32.3763 44.1549 32.2005 44.2266 31.9922 44.2266H28.0469C28.099 44.3568 28.1706 44.4805 28.2617 44.5977C28.3529 44.7148 28.4635 44.8255 28.5938 44.9297C28.9323 45.2943 29.3424 45.5807 29.8242 45.7891C30.306 45.9974 30.8203 46.1016 31.3672 46.1016C31.6016 46.1016 31.8424 46.0755 32.0898 46.0234C32.3372 45.9714 32.5651 45.9062 32.7734 45.8281Z"
            fill="#038846"
          />
        </svg>
        <h6>{{ "request-a-presentation.service-icon-4" | translate }}</h6>
      </div>
    </div>
  </div>
</section>
<!-- End OUR SERVICE -->

<!-- HOURLY PRICE TRENDS -->
<section class="container-analysis">
  <div class="main-analysis">
    <h6>{{ "request-a-presentation.analysis-h1" | translate }}</h6>
    <h1>{{ "request-a-presentation.analysis-h2" | translate }}</h1>
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-6 col-lg-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="inputGroupSelect01">{{
                "priceToday.market" | translate
              }}</label>
            </div>
            <select
              class="custom-select"
              [(ngModel)]="region"
              (change)="setRegion()"
              id="inputGroupSelect01"
            >
              <option selected [ngValue]="'sk'">Slovakia</option>
              <option [ngValue]="'cz'">Czech Republic</option>
              <option [ngValue]="'hu'">Hungary</option>
            </select>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4">
          <div class="input-group mb-3 text-right">
            <div class="input-group-prepend">
              <label class="input-group-text" for="inputGroupSelect01"
                >{{ "priceToday.from" | translate }}:</label
              >
            </div>
            <input
              type="date"
              [(ngModel)]="dateFrom"
              class="form-control"
              aria-label="Text input with checkbox"
              (change)="generateChart()"
            />
          </div>
        </div>

        <div class="col-12 col-sm-6 col-lg-4">
          <div class="input-group mb-3 text-right">
            <div class="input-group-prepend">
              <label class="input-group-text" for="inputGroupSelect01"
                >{{ "priceToday.until" | translate }}:</label
              >
            </div>
            <input
              type="date"
              [(ngModel)]="dateUntil"
              class="form-control"
              aria-label="Text input with checkbox"
              (change)="generateChart()"
            />
          </div>
        </div>
      </div>

      <div class="row text-center">
        <div
          class="col-12 col-sm-5"
          data-toggle="tooltip"
          data-placement="top"
          title="{{ 'priceToday.tooltip.spot' | translate }}"
        >
          <h2>{{ "priceToday.spot" | translate }}</h2>
          <div class="spotprice-box">{{ spotPrice }}€</div>
        </div>
        <div
          class="col-12 col-sm-5"
          data-toggle="tooltip"
          data-placement="top"
          title="{{ 'priceToday.tooltip.forecast' | translate }}"
        >
          <h2>{{ "priceToday.forecast" | translate }}</h2>
          <div class="backcast-box">{{ forecastPrice }}€</div>
        </div>
        <div
          class="col-12 col-sm-2"
          data-toggle="tooltip"
          data-placement="top"
          title="{{ 'priceToday.tooltip.trend' | translate }}"
        >
          <h2>{{ "priceToday.trend" | translate }}</h2>
          <div *ngIf="trendRising">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              fill="#00bf63"
              class="bi bi-arrow-up-right-square"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm5.854 8.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"
              />
            </svg>
          </div>
          <div *ngIf="!trendRising">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="64"
              height="64"
              fill="#00bf6350"
              class="bi bi-arrow-down-right-square"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm5.854 3.146a.5.5 0 1 0-.708.708L9.243 9.95H6.475a.5.5 0 1 0 0 1h3.975a.5.5 0 0 0 .5-.5V6.475a.5.5 0 1 0-1 0v2.768z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div>
        <div
          echarts
          [options]="chartOption"
          [loading]="isLoading"
          theme="macarons"
          class="demo-chart"
        ></div>
      </div>
    </div>
  </div>
</section>
<!-- END HOURLY PRICE TRENDS -->

<!-- WHY CHOOSE US -->
<section class="container-choose-us">
  <div class="main-choose-us">
    <div class="main-text-choose-us">
      <h6>{{ "request-a-presentation.choose-us-h1" | translate }}</h6>
      <h1>{{ "request-a-presentation.choose-us-h2" | translate }}</h1>
      <p>
        {{ "request-a-presentation.choose-us-p1" | translate }}
        <br /><br />
        {{ "request-a-presentation.choose-us-p2" | translate }}
      </p>
    </div>
    <div class="service-choose-us-image">
      <img src="../../assets/images/voltage-switchboard.webp" alt="Lightning" />
    </div>
  </div>
</section>
<!-- End WHY CHOOSE US -->

<!-- IMPLEMENTATION PROCESS -->
<section class="container-implementation">
  <div class="main-implementation">
    <h6>{{ "request-a-presentation.implementation-h1" | translate }}</h6>
    <h1>{{ "request-a-presentation.implementation-h2" | translate }}</h1>
    <div class="implementation-step">
      <div class="step"><h2>01</h2></div>
      <div class="step"><h2>02</h2></div>
      <div class="step"><h2>03</h2></div>
      <div class="step-info">
        <h6>{{ "request-a-presentation.implementation-h5" | translate }}</h6>
        <p>{{ "request-a-presentation.implementation-p9" | translate }}</p>
        <ul>
          <li>
            {{ "request-a-presentation.implementation-li14" | translate }}
          </li>
          <li>
            {{ "request-a-presentation.implementation-li15" | translate }}
          </li>
        </ul>
        <p>{{ "request-a-presentation.implementation-p10" | translate }}</p>
        <ul>
          <li>
            {{ "request-a-presentation.implementation-li16" | translate }}
          </li>
          <li>
            {{ "request-a-presentation.implementation-li17" | translate }}
          </li>
        </ul>
        <hr style="border: 1px solid #e1e1e1; margin: 20px 0" />
        <p>{{ "request-a-presentation.implementation-p11" | translate }}</p>
      </div>
      <div class="step-info">
        <h6>{{ "request-a-presentation.implementation-h3" | translate }}</h6>
        <p>{{ "request-a-presentation.implementation-p1" | translate }}</p>
        <ul>
          <li>{{ "request-a-presentation.implementation-li1" | translate }}</li>
          <li>{{ "request-a-presentation.implementation-li2" | translate }}</li>
        </ul>
        <p>{{ "request-a-presentation.implementation-p2" | translate }}</p>
        <ul>
          <li>{{ "request-a-presentation.implementation-li3" | translate }}</li>
        </ul>
        <p>{{ "request-a-presentation.implementation-p3" | translate }}</p>
        <ul>
          <li>{{ "request-a-presentation.implementation-li4" | translate }}</li>
          <li>{{ "request-a-presentation.implementation-li5" | translate }}</li>
        </ul>
        <hr style="border: 1px solid #e1e1e1; margin: 20px 0" />
        <p>{{ "request-a-presentation.implementation-p4" | translate }}</p>
      </div>
      <div class="step-info">
        <h6>{{ "request-a-presentation.implementation-h4" | translate }}</h6>
        <p>{{ "request-a-presentation.implementation-p5" | translate }}</p>
        <ul>
          <li>{{ "request-a-presentation.implementation-li6" | translate }}</li>
          <li>{{ "request-a-presentation.implementation-li7" | translate }}</li>
          <li>{{ "request-a-presentation.implementation-li8" | translate }}</li>
        </ul>
        <p>{{ "request-a-presentation.implementation-p6" | translate }}</p>
        <ul>
          <li>{{ "request-a-presentation.implementation-li9" | translate }}</li>
          <li>
            {{ "request-a-presentation.implementation-li10" | translate }}
          </li>
          <li>
            {{ "request-a-presentation.implementation-li11" | translate }}
          </li>
        </ul>
        <p>{{ "request-a-presentation.implementation-p7" | translate }}</p>
        <ul>
          <li>
            {{ "request-a-presentation.implementation-li12" | translate }}
          </li>
          <li>
            {{ "request-a-presentation.implementation-li13" | translate }}
          </li>
        </ul>
        <hr style="border: 1px solid #e1e1e1; margin: 20px 0" />
        <p>{{ "request-a-presentation.implementation-p8" | translate }}</p>
      </div>
    </div>
  </div>
</section>
<!-- End IMPLEMENTATION PROCESS -->

<section class="container-contact">
  <div class="main-contact">
    <h6>{{ "request-a-presentation.contact-h1" | translate }}</h6>
    <h1>{{ "request-a-presentation.contact-h2" | translate }}</h1>

    <div class="contact">
      <div class="contact-photo">
        <img src="../../assets/images/Erik.png" />
      </div>

      <div class="contact-information">
        <h3>Erik Majcher</h3>
        <p style="font-weight: bold">Project Manager</p>
        <br />
        <p>
          <a href="tel:+421910305306" class="contact-link">+421 910 30 53 06</a>
        </p>
        <p>
          <a href="mailto:majcher@novitechgroup.sk" class="contact-link"
            >majcher&#64;novitechgroup.sk</a
          >
        </p>
      </div>
    </div>
  </div>
</section>
